"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
var _utils = require("../utils");
var _AlphaGroupAGigisGreen = _interopRequireDefault(require("../../assets/images/Alpha-Group-A-Gigis-Green.png"));
var _AlphaFXAWhite = _interopRequireDefault(require("../../assets/images/Alpha-FX-A-White.png"));
var _AlphaFXWhite = _interopRequireDefault(require("../../assets/images/Alpha-FX-White.png"));
var _AlphaFXFullLogoOld = _interopRequireDefault(require("../../assets/images/Alpha-FX-Full-logo-old.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var theme = {
  typography: {
    fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontFamilySecondary: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontWeightLight: 300,
    fontWeightSemiBold: 600
  },
  background: {
    primary: '#fff',
    secondary: '#F7F9FC'
  },
  light: {
    persistantSideBar: {
      nav: {
        backgroundColor: 'rgb(0, 120, 105)'
      },
      mainHolder: {
        backgroundColor: '#1E8777'
      },
      link: {
        borderLeftColor: '#00a49a'
      },
      hover: {
        backgroundColor: 'rgb(0, 120, 105) !important'
      }
    }
  },
  dark: {
    persistantSideBar: {
      nav: {
        backgroundColor: '#222'
      },
      link: {
        borderLeftColor: 'rgba(0, 0, 0, 0.20)'
      }
    }
  },
  images: {
    logo: _AlphaGroupAGigisGreen["default"],
    fullLogo: _AlphaFXWhite["default"],
    whiteLogo: _AlphaFXAWhite["default"],
    fullGreenLogo: _AlphaFXFullLogoOld["default"]
  },
  palette: {
    primary: {
      light: '#3a9b90',
      main: '#1E8777',
      dark: '#065b51',
      contrastText: '#fff'
    },
    secondary: {
      light: '#5c5c5c',
      main: '#222222',
      dark: '#242424'
    },
    text: {
      primary: '#212529',
      secondary: '#16181b'
    },
    error: {
      main: '#b95656'
    },
    info: {
      main: '#197fab'
    },
    warning: {
      main: '#ffc107'
    },
    success: {
      main: '#3a9b90'
    }
  },
  shadows: ['none', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029', '0 3px 6px #00000029'],
  utils: {
    shade: _utils.shade
  },
  layout: {
    sidePadding: 60
  }
};
exports.theme = theme;